<template>
  <v-row>
    <div v-for="action in actionGroup" :key="action.id">
      <Confirm
        v-if="action.requireConfirmation && !action.requireInput"
        :buttonIcon="action.icon | addMdi"
        :dialogTitle="$t('ConfirmAction')"
        :disabled="action.disabled"
        :dialogText="$t('CardActions.' + action.name)"
        :okText="$t('Continue')"
        :cancelText="$t('Cancel')"
        :tooltipText="$t('CardActions.' + action.name)"
        v-on:ok="() => $emit('executeAction', action, 'Ошибка')"
      />
      <Promt
        v-else-if="action.requireInput"
        :buttonIcon="action.icon | addMdi"
        :dialogTitle="$t('CardActions.' + action.name)"
        :textLable="$t('CardActions.DialogText.' + action.name)"
        :disabled="action.disabled"
        :okText="$t('Continue')"
        :cancelText="$t('Cancel')"
        :tooltipText="$t('CardActions.' + action.name)"
        v-on:ok="(text) => $emit('executeAction', action, text)"
      />
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on: tooltip }">
          <div>
            <v-btn
              :disabled="action.disabled"
              class="mr-1"
              small
              color="primary"
              v-on="{ ...tooltip }"
              icon
              v-on:click="(text) => $emit('executeAction', action, 'Ошибка')"
            >
              <v-icon>{{ action.icon | addMdi }}</v-icon>
            </v-btn>
          </div>
        </template>
        <span>{{ $t("CardActions." + action.name) }}</span>
      </v-tooltip>
    </div>
  </v-row>
</template>
<script>
import Promt from '@/components/Dialogs/Promt';
import Confirm from '@/components/Dialogs/Confirm';

export default {
  props: {
    actionGroup: Array,
  },
  components: {
    Promt,
    Confirm,
  },
  filters: {
    addMdi(icon) {
      return 'mdi-' + icon;
    },
  },
};
</script>
